import { connect } from 'react-redux';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import Modal from 'kepler/lib/components/Modal';
import ModalBody from 'kepler/lib/components/ModalBody';
import { closeChatIneligibleModalContainer } from '../actions/action-chat-ineligible-modal';
import { trackLink, trackPage } from '../../lib/analytics-helper';
import i18n from '../../lib/reacti18n';
import Page from '../../lib/page';

const chatBotInEligibile = {
  chatBotHeader: i18n.message('smarthelp/chatBot.chatBot.error.header'),
  chatBotMsg: i18n.message('smarthelp/chatBot.chatBot.error.loginMessage'),
  okBtn: i18n.message('smarthelp/chatBot.chatBot.error.ok'),
};

class ChatInEligibleModalContainer extends Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.fptId = (Page.getPageName() === 'contact-us') ? 'chatBot' : 'chatBotArticleInEligible';
  }

  // Send FPTi request when intermediate page open
  componentWillUpdate(nextProps) {
    if (this.props.isChatModalOpen === false && nextProps.isChatModalOpen === true) {
      trackPage({ id: this.fptId, link: 'article-chat-ineligible|open' });
    }
  }

  closeModal() {
    trackLink({ id: this.fptId, link: 'article-chat-ineligible|close' });
    return this.props.closeChatIneligibleModalContainer();
  }

  render() {
    return (
      <div>
        <Modal
          isOpen={this.props.isChatModalOpen} type="dialog" width="medium"
          onCancel={this.closeModal}
        >
          <ModalBody>
            <div className="text-center">
              <div className="login">{chatBotInEligibile.chatBotHeader}</div>
              <div className="login">{chatBotInEligibile.chatBotMsg}</div>
              <button className="login_btn btn" onClick={this.closeModal}>{chatBotInEligibile.okBtn}</button>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    isChatModalOpen: state.chatInEligibleModal.isChatModalOpen,
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators({ closeChatIneligibleModalContainer }, dispatch);
}

ChatInEligibleModalContainer.propTypes = {
  closeChatIneligibleModalContainer: PropTypes.func.isRequired,
  isChatModalOpen: PropTypes.bool.isRequired,
};

ChatInEligibleModalContainer.defaultProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(ChatInEligibleModalContainer);
